import { React } from 'react';
import { Monitor } from "./Monitor";

function MainRisk() {
  return (
    <Monitor />
  );
}
export default MainRisk;
